import { render } from "./test-results.vue?vue&type=template&id=3be33d4e&scoped=true"
import script from "./test-results.vue?vue&type=script&lang=js"
export * from "./test-results.vue?vue&type=script&lang=js"

import "./test-results.vue?vue&type=style&index=0&id=3be33d4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be33d4e"]])

export default __exports__